import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import PageText from "../components/PageText";
import PageTitle from "../components/PageTitle";
import SectionBox from "../components/SectionBox";

export default function NotFound() {
  return (
    <Layout>
      <Helmet>
        <title>Page not found | CHAOTIK</title>
        <meta name="robots" content="noindex" />
        <meta
          name="description"
          content="That page drifted out of the nav grid. Head back to the CHAOTIK home page or join our Discord."
        />
      </Helmet>

      <div className="flex flex-col items-center text-center mt-16 mb-24">
        <SectionBox>
          <PageTitle>404 &mdash; Out of nav grid</PageTitle>
          <PageText>
            <p className="text-center break-normal p-2 sm:p-4">
              That page isn't on our flight plan. The link might be stale, or the route may have
              been retired.
            </p>
            <p className="text-center break-normal p-2 sm:p-4">
              Head back to the home page, or jump on Discord and someone will point you at what
              you're after.
            </p>
          </PageText>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="bg-[#96000b] text-black text-lg sm:text-xl md:text-2xl font-bold px-6 py-3 rounded-md transition-all duration-300 hover:bg-red-800 hover:scale-105 active:bg-white active:text-black"
            >
              Back to Home
            </Link>
            <a
              href="https://discord.gg/CHAOTIK"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-black/60 text-white text-lg sm:text-xl md:text-2xl font-bold px-6 py-3 rounded-md ring-1 ring-[#96000b]/60 transition-all duration-300 hover:bg-black/80 hover:scale-105"
            >
              Join Discord
            </a>
          </div>
        </SectionBox>
      </div>
    </Layout>
  );
}
